import React, { memo, ReactElement, useEffect, useState } from 'react'
import { Spin } from 'antd'
import { Translate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import { IAuditEventsDetailsState, TAuditEventsDetailsProps } from './AuditLogsDetail.types'
import { fetchAuditEvent } from '../audit-logs/AuditLogs.actions'
import { getEvent } from './AuditEventsDetail.selectors'
import { emptyAuditEvent } from './AuditEventsDetail.constants'
import { formatDateWithTimestamp } from 'shared/helpers/utils'
import { Spinner } from '@digicert/dcone-common-ui'
import styles from './AuditEventsDetail.module.scss'
import { IAuditLogsEvent } from '../audit-logs/AuditLogs.types'

const dcOneSpinner = <Spinner/>

const AuditEventsDetail = ({ event, fetchAuditEvent, match, profile }: TAuditEventsDetailsProps): ReactElement => {
  const [ loading, setLoading ] = useState(false)
  const [ eventRender, setEvent ] = useState(event || emptyAuditEvent)
  const id = match.params.id
  useEffect(() => {
    if (event) {
      return
    }
    setLoading(true)
    fetchAuditEvent(id)
    .then((eventRes: IAuditLogsEvent) => {
      setEvent(eventRes)
    })
    .finally(() => setLoading(false))
  }, [fetchAuditEvent, id]) // eslint-disable-line react-hooks/exhaustive-deps
  return eventRender ? (
    <Spin tip={'Loading...'} spinning={loading} indicator={dcOneSpinner}>
      <div className={styles.auditEvents}>
        <header>
          <h1>
            <Translate id='reporting.auditEvents.titleDetails' />
          </h1>
        </header>

        <p><b><Translate id='reporting.auditEvents.eventId' />:</b> {eventRender.id}</p>
        <p>
          <b><Translate id='common.action' />:</b>&nbsp;
          {eventRender.action}
        </p>
        <p><b><Translate id='common.date' />:</b> {formatDateWithTimestamp(eventRender.timestamp, profile?.date_format as string)}</p>
        <p><b><Translate id='reporting.auditEvents.resourceType.title' />:</b> <Translate id= {`reporting.auditEvents.resourceType.${eventRender.resource_type}`}/></p>
        <p><b><Translate id='reporting.auditEvents.resourceId' />:</b> {eventRender.resource_id}</p>
        <p><b><Translate id='common.description' />:</b> {eventRender.description}</p>
        <p><b><Translate id='common.form.status' />:</b> {eventRender.status}</p>
        <p><b><Translate id='common.form.clientIp' />:</b> {eventRender.client_ip}</p>
      </div>
    </Spin>
  ) : <></>
}

AuditEventsDetail.displayName = 'AuditEventsDetail'

export default connect(
  (state: IAppState, props): IAuditEventsDetailsState => ({
    event: getEvent(state, props),
    profile: state.profile.data
  }),
  { fetchAuditEvent }
)(memo(AuditEventsDetail))
